const PayType = Object.freeze({
  B: "Cash & stock",
  C: "Cash",
  D: "Dissenter rights",
  S: "Stock",
  T: "To be announced",
});

export default PayType;
